// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  CreateActionResult,
  CreateActionResultFromJSON,
  CreateActionResultToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  Filter,
  FilterFromJSON,
  FilterToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  SaveFilterPayload,
  SaveFilterPayloadFromJSON,
  SaveFilterPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface DeleteFilterRequest {
  project: number;
  id: number;
}

export interface GetFilterRequest {
  project: number;
  id: number;
}

export interface GetFilterListRequest {
  project: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface SaveFilterRequest {
  project: number;
  saveFilterPayload?: SaveFilterPayload;
}

/**
 * no description
 */
export class FiltersApi extends runtime.BaseAPI {
  /**
   * Deletes a saved filter
   * Deletes a saved filter
   */
  async deleteFilterRaw(
    requestParameters: DeleteFilterRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteFilter."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteFilter."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/project/filters/delete/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes a saved filter
   * Deletes a saved filter
   */
  async deleteFilter(requestParameters: DeleteFilterRequest): Promise<any> {
    const response = await this.deleteFilterRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of a saved filter
   * Get a saved filter
   */
  async getFilterRaw(
    requestParameters: GetFilterRequest
  ): Promise<runtime.ApiResponse<Filter>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getFilter."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getFilter."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/project/filters/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FilterFromJSON(jsonValue)
    );
  }

  /**
   * Get details of a saved filter
   * Get a saved filter
   */
  async getFilter(requestParameters: GetFilterRequest): Promise<Filter> {
    const response = await this.getFilterRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get list of all the saved filters
   * Get saved filters
   */
  async getFilterListRaw(
    requestParameters: GetFilterListRequest
  ): Promise<runtime.ApiResponse<Array<Filter>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getFilterList."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/project/filters`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FilterFromJSON)
    );
  }

  /**
   * Get list of all the saved filters
   * Get saved filters
   */
  async getFilterList(
    requestParameters: GetFilterListRequest
  ): Promise<Array<Filter>> {
    const response = await this.getFilterListRaw(requestParameters);
    return await response.value();
  }

  /**
   * Adds a new saved filters
   * Adds a new saved filters
   */
  async saveFilterRaw(
    requestParameters: SaveFilterRequest
  ): Promise<runtime.ApiResponse<CreateActionResult>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling saveFilter."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/project/filters/add`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SaveFilterPayloadToJSON(requestParameters.saveFilterPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Adds a new saved filters
   * Adds a new saved filters
   */
  async saveFilter(
    requestParameters: SaveFilterRequest
  ): Promise<CreateActionResult> {
    const response = await this.saveFilterRaw(requestParameters);
    return await response.value();
  }
}
